export const capitalize = (word: string | number): string | number => {
	if (typeof word === "number") {
		return word;
	}
	return word[0].toUpperCase() + word.slice(1);
};
